import React from 'react'
import { format, isToday } from 'date-fns'
import { Button } from 'reactstrap'
import SuccessConfettireg from '../../../assets/check-reg.png'
import { ReactComponent as CopyIcon } from '../../../assets/copyIcon.svg'
import styles from 'components/Registration/Form/signupStyles.module.css'

import { getExamType } from 'utils/common'
import { connect } from 'react-redux'
import { SET_TOAST_DATA } from 'constants/actionTypes'
import { webEngageDob } from 'utils/dateTime'

const mapDispatchToProps = (dispatch) => ({
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
})

const SignupSuccessful = ({ signupSuccessDetails, setToastMsgsData }) => {


    const [examSlot, setExamSlot] = React.useState('')

    React.useEffect(() => {
        const storedSlot = localStorage.getItem('exam_slots')

        if (storedSlot) {
            setExamSlot(storedSlot)
        }
    }, [])
    React.useEffect(() => {
        window.scroll({
            top: window.innerWidth > 768 ? 130 : 375,
            behavior: 'smooth',
        })
    }, [])

    const examType = getExamType()
    const isNeetMockRoute = "MOCK-NEET" === examType;
    
    React.useEffect(() => {
        const urlWithParams = new URL(window.location.href)
        urlWithParams.searchParams.set('pmstatus', 'success')
        window.history.replaceState({}, '', urlWithParams.href)
        window.dataLayer.push({
            event: 'iacst_complete_registration_v1',
        })
        // Clean up function to revert the URL back to its original state
        return () => {
            window.history.replaceState({}, '', window.location.href)
        }
    }, [])

    React.useEffect(() => {
        if (isNeetMockRoute || examType == 'IAT' || examType == "MOCK-JEE" && localStorage.getItem('user_info') && localStorage.getItem('exam_info')) {
            let user_infodata = localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')) : ""
            let exam_infodata = localStorage.getItem('exam_info') ? JSON.parse(localStorage.getItem('exam_info')) : ""
            window.webengage.track(examType + '6_payment_status_success', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                'mobile number': user_infodata.mobileNumber
                    ? user_infodata.mobileNumber
                    : '',
                board: exam_infodata.schoolBoard?.value
                    ? exam_infodata.schoolBoard?.value
                    : '',
                student_name: user_infodata.studentName
                    ? user_infodata.studentName
                    : '',
                dob: new Date(user_infodata.dob) ? new Date(user_infodata.dob) : '',
                email_ID: user_infodata.email ? user_infodata.email : '',
                class: exam_infodata.classStream?.class
                    ? exam_infodata.classStream?.class
                    : '',
                city: user_infodata.city ? user_infodata.city : '',
                page_url: window.location.href ? window.location.href : '',
                pincode: user_infodata.pincode ? user_infodata.pincode : '',
                state: user_infodata.state ? user_infodata.state : '',
                exam_mode: localStorage.getItem("exam_mode"),
                exam_state: exam_infodata.state?.label
                    ? exam_infodata.state?.label
                    : '',
                'branch name': exam_infodata.centre?.label
                    ? exam_infodata.centre?.label
                    : '',
                'branch code': exam_infodata.centre?.centreCode
                    ? exam_infodata.centre?.centreCode
                    : '',
                exam_date: new Date(
                    exam_infodata.dateOfExam?.value + 'T03:30:00.000Z',
                )
                    ? new Date(exam_infodata.dateOfExam?.value + 'T03:30:00.000Z')
                    : '',
                dashboard_password: webEngageDob(user_infodata.dob)
                    ? webEngageDob(user_infodata.dob)
                    : '',
                payment_status: 'success',
                exam_type: examType,
                exam_fee: localStorage.getItem('exam_fee')
                    ? Number(localStorage.getItem('exam_fee'))
                    : 0,
                psid: localStorage.getItem('user_psid')
                    ? localStorage.getItem('user_psid')
                    : '',
                coupon_code: localStorage.getItem('coupon_code')
                    ? localStorage.getItem('coupon_code')
                    : '',
            })
        }
    }, [])

    React.useEffect(() => {
        if (isNeetMockRoute || examType == 'IAT' || examType == "MOCK-JEE") {
            window.webengage.track(examType + '8_Thank_You_Page', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                roll_number: signupSuccessDetails.roll_number,
                exam_type: examType,
                dob: signupSuccessDetails.dob,
            })
        }
    }, [])

    const handleCopyRollNum = () => {
        if (isNeetMockRoute || examType == 'IAT' || examType=="MOCK-JEE") {
            window.webengage.track(examType + '9_Thank_You_rollno_copy', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                roll_number: signupSuccessDetails.roll_number,
                exam_type: examType,
                dob: signupSuccessDetails.dob,
            })
        }
        navigator.clipboard
            .writeText(signupSuccessDetails.roll_number)
            .then(function () {
                setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'warn',
                    toastMessage: 'Copied to clipboard !',
                })
            })
            .catch((err) => {
                setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'error',
                    toastMessage: 'Could not copy text.',
                })
            })
    }

    const formattedDate = () => {
        return format(new Date(signupSuccessDetails.exam_date), 'dd MMM yyyy')
    }

    const isExamToday = isToday(new Date(signupSuccessDetails.exam_date))

    return (
        <>
            <div className="text-center p-3 pb-0">
                <img src={SuccessConfettireg} alt="success" className="w-2" />
                <p className="fw-lighter font-size-lg text-dark-green">
                    Registration Successful
                </p>
            </div>

            <div className="px-lg-4 px-3 my-4 text-light-grey-200">
                <div>
                    <p className="fw-lighter mb-2">Login details</p>
                    <div className="d-flex align-item-center justify-content-between">
                        <p className="font-size-sm mb-0">
                            Roll number:{' '}
                            <span className="fw-500">
                                {signupSuccessDetails.roll_number}
                            </span>
                        </p>

                        <p
                            className="text-aqua fw-lighter font-size-xs mb-0 cursor-pointer"
                            onClick={handleCopyRollNum}
                        >
                            Copy
                            <span className="ms-2">
                                <CopyIcon />
                            </span>
                        </p>
                    </div>

                    <div className="d-flex align-item-center justify-content-between mt-1">
                        <p className="font-size-sm">
                            Password:{' '}
                            <span className="fw-500">
                                {signupSuccessDetails.dob}
                            </span>
                        </p>
                        <p className="text-grey font-size-xs">Date of birth</p>
                    </div>
                </div>

                {getExamType() !== 'MOCK-JEE' && (
                   <div style={{ borderTop: '2px dotted #757575' }}>
                    <p className="fw-lighter mt-3 mb-2">Exam schedule</p>
                        {signupSuccessDetails.exam_date && (
                            <p className="font-size-sm mb-1">
                                {formattedDate(signupSuccessDetails.exam_date)} | {examSlot}
                            </p>
                        )}
                    </div>
)}
            </div>

            <div className="p-3 pb-2 shadow-top">
                {getExamType() !== 'MOCK-NEET' && (
                    <p className="text-center fw-500 font-size-sm text-grey-black">
                        {
                            getExamType() === 'IAT'
                                ? 'To download admit card'
                                : getExamType() === 'MOCK-JEE'
                                ? 'To access your test series'
                                : isExamToday
                                ? 'To begin the test'
                                : 'For test prep guidance'
                        }                          
                    </p>
                )}

                <Button
                    className={`btn btn-aqua text-white w-100 fw-bold font-size-sm ${styles.sendOtpButton}`}
                    onClick={() => {
                        if (isNeetMockRoute || examType == 'IAT' || examType=="MOCK-JEE") {
                            window.webengage.track(
                                examType + '10_Thank_You_Go_To_Dashboard',
                                {
                                    'utm parameters': localStorage.getItem(
                                        'utmParams',
                                    )
                                        ? localStorage.getItem('utmParams')
                                        : '',
                                    dob: signupSuccessDetails.dob,
                                    exam_type: examType,
                                    roll_number: signupSuccessDetails.roll_number,
                                },
                            )
                        }

                        // window.location.href =
                        //     signupSuccessDetails?.dashboard_link ||
                        //     `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`

                        const utmRaw = localStorage.getItem('utmParams');
                        let finalUrl = "";
                
                        if (utmRaw && examType == "iACST") {
                            try {
                                const utmParams = JSON.parse(utmRaw);
                                const queryParams = new URLSearchParams(utmParams);
                                finalUrl = signupSuccessDetails?.dashboard_link ? 
                                          `${signupSuccessDetails?.dashboard_link}&${queryParams.toString()}`:
                                          `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`;                                    
                                window.location.href = finalUrl;
                            } catch (e) {
                                console.error('Invalid UTM Params in localStorage', e);
                            }
                        }
                        else{
                            window.location.href =
                            signupSuccessDetails?.dashboard_link ||
                            `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`
                        }
                    }}
                >
                    Go to dashboard
                </Button>
            </div>
        </>
    )
}

export default connect(null, mapDispatchToProps)(SignupSuccessful)
